import type {ApiService} from '~/services/ApiService';
import type {SetPasswordRequest, UserInvitationRequest} from '~~/api/models';
import type {InvitationPasswordResponse, InvitationStatus} from '~/types/invitation';

export class InvitationService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  async getInvitation(invitation: string): Promise<InvitationStatus> {
    return this.apiService.get<InvitationStatus>(`/api/invitation/${encodeURIComponent(invitation)}`);
  }

  async updateInvitation(invitation: string, request: UserInvitationRequest): Promise<boolean> {
    return this.apiService.put<boolean>(`/api/invitation/${encodeURIComponent(invitation)}`, {
      body: request
    });
  }

  async setUserPassword(invitation: string, request: SetPasswordRequest): Promise<InvitationPasswordResponse> {
    return this.apiService.post<InvitationPasswordResponse>(`/api/invitation/${encodeURIComponent(invitation)}/password`, {
      body: request
    });
  }

  async finalizeInvitation(invitation: string): Promise<boolean> {
    return this.apiService.post<boolean>(`/api/invitation/${encodeURIComponent(invitation)}/finalize`);
  }
}